import { forEach, merge, reduce, set, get } from 'lodash';
import React, { Component, PropTypes } from 'react';
import AddContact from '../../../../../../common/components/AddContact';
import ModalX from '../../../../../../common/svgs/ModalX';
import { reduceToValues, mapFormFields, updateFormFields, fieldsHasErrors } from '../../../../../../lib/form';
import { validateFormField } from '../../../../../../modelValidator';
import * as companyApi from '../../../../../../redux/actionCreators/async/companies';
import * as companyStore from '../../../../../../redux/actionCreators/sync/companies';
import * as ui from '../../../../../../redux/actionCreators/sync/ui';

const fieldList = ['user.firstName', 'user.lastName', 'profile.title', 'user.email', 'user.address', 'user.city', 'user.state', 'user.zip', 'user.phoneNumber1', 'user.phoneType1', 'user.phoneExtension1', 'profile.department', 'user.timezone', 'profile.types'];
const labels = ['First Name', 'Last Name', 'Contact Title', 'Email Address', 'Address', 'City', 'State', 'Zip', 'Phone Number', 'Phone Type', 'Extension', 'Department', 'Timezone', 'Type of Contact'];

const fields = {
  user: {
    required: ['user.firstName', 'user.lastName', 'user.email', 'user.phoneNumber1', 'user.city', 'user.state'],
  },
  profile: {
    required: ['profile.title']
  },
};

export default class NewCompanyContact extends Component {

  static propTypes = {
    dispatch  : PropTypes.func.isRequired,
    onClose   : PropTypes.func.isRequired,
    company   : PropTypes.object.isRequired,
    contacts  : PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired
  }

  static defaultProps = {
    company: {},
    contacts: [],
  };

  constructor(props) {
    super(props);
    this.handleChange = ::this.handleChange;

    this.state = merge({}, mapFormFields({}, fields.user.required), mapFormFields({}, fields.profile.required), {isDirty: false, emailDuplicate: false});

    // set default values
    set(this.state, 'user.address.value', this.props.company.address);
    set(this.state, 'user.city.value', this.props.company.city);
    set(this.state, 'user.state.value', this.props.company.state);
    set(this.state, 'user.zip.value', this.props.company.zip);
  }


  validateContactForm(formState) {
    forEach(fields, (model) =>
      forEach(model.required, (field) =>
        set(formState, `${field}.errors`, validateFormField(field, formState))
      )
    );
  }

  handleUpdate = (event, prop, value) =>
  {
    const state = merge({}, this.state, { isDirty: true });
    updateFormFields(state, prop, value);
    this.validateContactForm(state); // state is modified by this function
    this.setState(state);
  }

  handleChange() {
    // set state's dirty status to: true;
    this.setState(merge({}, this.state, { isDirty: true}));
  }

  handleCancel = () => {
    if(this.props.onClose) {
      this.props.onClose();
    }

  }

  handleSave = () => {
    const { dispatch, company, contacts } = this.props;
    const newContact = { user: reduceToValues(this.state.user), profile: reduceToValues(this.state.profile) };
    set(newContact, 'profile.companyId', company.id);
    set(newContact, 'profile.foundUsVia', 55); // Other

    dispatch(companyApi.addCompanyContacts(newContact, (err, data) => {
      if (err) {

        if (err.status === 'fail') {
          const hasErrors = !!reduce(this.state, (errors, obj) => errors || fieldsHasErrors(obj), false);
          const newState = merge({}, this.state, {isDirty: false, hasErrors});

          if (get(err, 'errors[0].errorMessage', '') === 'User with that email already exists.') {
            set(newState, 'emailDuplicate', true);
          }

          this.setState(newState);
        }
        return console.error(err);
      }

      dispatch(companyStore.updateCompanyContacts([...contacts, data]));
      dispatch(ui.showSnackBar(`${newContact.user.firstName} ${newContact.user.lastName} has been added`));
      this.handleCancel();
    }));
  }

  render() {

    return (
      <div className='company-card'>
        <div className='worksheet-add-contact-container'>
          <div className='add-contact-form'>
            <h1 className='heading'>Add Contact <ModalX onClick={this.props.onClose} style={{color: '#000'}} className='close-button' /></h1>
            <AddContact
              model={this.state}
              emailDuplicate={this.state.emailDuplicate}
              fields={fieldList}
              labels={labels}
              staticData={this.props.staticData}
              hasErrors={this.state.hasErrors}
              onUpdate={this.handleUpdate}
              onChange={this.handleChange}
              onCancel={this.handleCancel}
              onSave={this.handleSave}
              disableSave={!this.state.isDirty}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Worksheet/Header/NewContact/index.js